import React, { Component } from 'react';

export class SendInvite extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.inviteSubmit = this.inviteSubmit.bind(this);
        this.state ={ teamId: this.props.teamId, inviteSender: this.props.accNum, emailInvite: '', message: '' };
       
    }
    componentDidMount() {
      
        this._isMounted = true;

    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    onChangeEmail(e) {
        this.setState({
            emailInvite: e.target.value
        });
    }

    async inviteSubmit(e) {
        e.preventDefault();

        var data = { sender: this.state.inviteSender, recipient: this.state.emailInvite, teamId:this.state.teamId};

       

        const resp = await fetch('api/team/sendinvite', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }

        });

        var respData = null;
        try {
            respData = await resp.json();
         
        } catch (e) {
            console.log(resp.respData);
            this.setState({ message: '500: Check console' })
        }

      
        if (resp.status === 200) {
            this.props.saveSuccess();
        }
        else if (resp.status === 401) {
            this.setState({ message: '401: Not Authorized' })
        }
        else if (resp.status === 400) {
            console.log(respData);
            this.setState({ message: respData.statusText })
        }
        else if (resp.status === 404) {
            this.setState({ message: resp.statusText })
        }
        else {
            this.setState({ message: 'There was a problem, please try again later' });
        }
    }
    render() {
        const invite = (
            <div class="input-group">
                <input type="text" className="form-control" name="Email" id="text" maxLength="50"
                    placeholder="Email address"
                    value={this.state.emailInvite} onChange={this.onChangeEmail} />

                        <input type="hidden" name="icon" className="item-menu" />

                <div class="input-group-append">
                    <input type="submit" value="Send Invite" className="btn btn-secondary" onClick={this.inviteSubmit} />
                </div>
                
            </div>
           );
        const error = (<div className="text-danger card">{this.state.message}</div>);
        return (<div>
            {invite}
            {error}
        </div>);
    }
}
